// RegimeSelector.js
import React from 'react';
import './RegimeSelector.css';
import oldIcon from '../Assets/icons/article.svg'; 
import newIcon from '../Assets/icons/article.svg'; 

const RegimeSelector = ({ onSelectRegime }) => {
  return (
    <div className="regime-selector">
      <p>Do you have opt-in any regime?</p>
      <div className="buttons">
        <button className="regime-button" onClick={() => onSelectRegime('old')}>
          <img src={oldIcon} alt="Old Regime" className="icon" />
          Old Regime
        </button>
        <button className="regime-button" onClick={() => onSelectRegime('new')}>
          <img src={newIcon} alt="New Regime" className="icon" />
          New Regime
        </button>
      </div>
    </div>
  );
};

export default RegimeSelector;
